import { CreateGMWEventBase, EditGMWEventBase } from "@nens/brostar/uploadapi-client";
import { SchemaForFormData } from "@nens/shared-utils";

import { getDocsLinkMarkdown, getTitleAddon } from "@/libs/form-utils";
import { FormType } from "@/types/form-types";

import { pickGmwLibraryFields } from "../../../schema/gmw-schema-library";

const sharedTitle = (type: FormType | undefined) => `GMW Gebeurtenis ${getTitleAddon(type)}`;
const sharedDescription = `Dit is het GMW gebeurtenis formulier. Vul de onderstaande velden in en maak monitoringsbuizen aan om een GMW aan te maken. ${getDocsLinkMarkdown(
  "GMW"
)}`;

const sharedSourcedocumentData = {
  type: "object" as const,
  title: "Gebeurtenis gegevens",
  required: ["eventDate"],
  properties: pickGmwLibraryFields(["eventDate"]),
};

const getGmwEventCreateBaseSchema = (
  type: FormType | undefined
): SchemaForFormData<CreateGMWEventBase> => ({
  type: "object",
  title: sharedTitle(type),
  description: sharedDescription,
  required: ["registrationType", "metadata", "sourcedocumentData"],
  properties: {
    ...pickGmwLibraryFields(["registrationType"]),
    sourcedocumentData: sharedSourcedocumentData,
    metadata: {
      type: "object",
      title: "Metadata",
      required: ["projectNumber", "deliveryAccountableParty", "qualityRegime"],
      properties: pickGmwLibraryFields([
        "projectNumber",
        "broId",
        "qualityRegime",
        "deliveryAccountableParty",
      ]),
    },
  },
});

const getGmwEventEditBaseSchema = (
  type: FormType | undefined
): SchemaForFormData<EditGMWEventBase> => ({
  type: "object",
  title: sharedTitle(type),
  description: sharedDescription,
  required: ["registrationType", "metadata", "sourcedocumentData"],
  properties: {
    registrationType: {
      ...pickGmwLibraryFields(["registrationType"]).registrationType,
      readOnly: true,
    },
    sourcedocumentData: sharedSourcedocumentData,
    metadata: {
      type: "object",
      title: "Metadata",
      required: [
        "projectNumber",
        "broId",
        "deliveryAccountableParty",
        "qualityRegime",
        "correctionReason",
      ],
      properties: {
        ...pickGmwLibraryFields([
          "projectNumber",
          "qualityRegime",
          "deliveryAccountableParty",
          "correctionReason",
        ]),
        broId: { ...pickGmwLibraryFields(["broId"]).broId, readOnly: true },
      },
    },
  },
});

export function getGmwEventBaseSchema(args: {
  type: FormType | undefined;
  isEditing: true;
}): SchemaForFormData<EditGMWEventBase>;
export function getGmwEventBaseSchema(args: {
  type: FormType | undefined;
  isEditing: false;
}): SchemaForFormData<CreateGMWEventBase>;
export function getGmwEventBaseSchema(args: {
  type: FormType | undefined;
  isEditing: boolean;
}): SchemaForFormData<EditGMWEventBase> | SchemaForFormData<CreateGMWEventBase>;
export function getGmwEventBaseSchema({
  type,
  isEditing,
}: {
  type: FormType | undefined;
  isEditing: boolean;
}) {
  return isEditing ? getGmwEventEditBaseSchema(type) : getGmwEventCreateBaseSchema(type);
}
